import { Block } from 'components/Block'
import { GuidebookStep, stepCloseAccountsData } from 'components/content/guidebook/content'
import { highlightedParagraphCss, SGridWrapper } from './GuidebookStepCloseAccounts.styled'
import { GuidebookStepHeader } from 'components/content/guidebook/guidebookStepHeader/GuidebookStepHeader'
import { HighlightedParagraph } from 'components/highlightedParagraph/HighlightedParagraph'
import { Picture } from 'components/picture/Picture'
import { TranslatableLink } from 'components/TranslatableLink'
import { Trans, useTranslation } from 'next-i18next'
import { numberRange } from 'utils/general'

export function GuidebookStepCloseAccounts(props: { step: GuidebookStep }) {
  const { t } = useTranslation('eol_guide')

  return (
    <>
      <GuidebookStepHeader
        step={props.step}
        description={
          <Trans
            t={t}
            i18nKey="eol_guide.step_4.description"
            components={{ tc: <TranslatableLink href="/me/trusted-contact" /> }}
          />
        }
        image={<Picture imageKey={'illustrations/vault'} sizes={'700px'} />}
      />
      <Block>
        <SGridWrapper>
          {numberRange(8).map((i) => (
            <HighlightedParagraph
              key={i}
              wrapperCss={highlightedParagraphCss}
              title={t(`eol_guide.step_4.item_${i}`)}
              iconProps={{ size: '2rem' }}
              {...stepCloseAccountsData[i]}
            />
          ))}
        </SGridWrapper>
      </Block>
    </>
  )
}
